import { Component, OnInit, Input } from '@angular/core';
import { Search, CrudService, Attach, SortDirection, Page, MessageService, SharedDataService } from 'elbuild-ui-lib-core';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User, UserType } from 'toolbandi-ui-lib';
import { DialogService } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-deliverable-attachments',
	templateUrl: './deliverable-attachments.component.html',
	styleUrls: ['./deliverable-attachments.component.scss']
})
export class DeliverableAttachmentsComponent implements OnInit {

	@Input()
	deliverableid: number;
	rows: Attach[];

	loading: boolean = true;
	advancedSearch: Search = new Search('attach');
	page: Page = new Page(30);
	bootstrap = true;

	today = new Date().getTime();
	hideid = false;

	isAdmin: boolean;

	constructor(
		private attachService: CrudService<Attach>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private activeModal: NgbActiveModal,
		private sharedDataService: SharedDataService,
		private dialogService: DialogService
	) {
		this.advancedSearch.setSortDirection(SortDirection.DESCENDING);
		this.advancedSearch.setSortField('id');
		this.advancedSearch.addSimpleFilter('entity', 'deliverable');

		this.sharedDataService.currentLoggedUser.subscribe((data) => {
			if (data) {
				this.isAdmin = ((data as User).utype === UserType.admin);
			}
		});
	}

	ngOnInit(): void {
		this.loadAttach();
	}

	loadAttach(): void {
		if (this.deliverableid) {
			this.advancedSearch.addSimpleFilter('eid', this.deliverableid);

			this.loading = true;
			this.rows = [];

			const datarequest = this.attachService.searchEntities(Attach, 'attach', this.advancedSearch, this.page);
			const countrequest = this.attachService.countEntities(Attach, 'attach', this.advancedSearch);

			forkJoin([datarequest, countrequest]).subscribe(results => {
				this.page.setTotal(results[1].ct);
				this.rows = results[0].map((r: Attach) => {

					return r;
				});
				this.loading = false;

			}, ({ error }) => {
				this.messageService.sendError(error, this.translateService.instant('labels.attach'));
				this.loading = false;
			});
		}
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	delete(row: Attach) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-attach-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.attachService.deleteEntity(Attach, 'attach', row).subscribe(() => {
					this.translateService.get(['labels.attach-deleted', 'labels.attach']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.attach-deleted'], messages['labels.attach']);
						this.loadAttach();
					});
				});
			}
		});
	}

}
